// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__21BnC","content":"GlobalSearch_content__1feXp"};